<script>
import config from "@/helpers/config"
import Logo from '@/components/Logo.vue'
import niceFunctions from "@/helpers/niceFunctions"

export default {
  components: { Logo },
  data() {
    return {  
      showMobileMenu: false
    }
  },
  computed: {
    url() { return config.urlToServer }, 
    publicPageColors() { return this.$store.state.publicPage != null ? this.$store.state.publicPage.publicPageColors : null },
    publicPageImages() { return this.$store.state.publicPage != null ? this.$store.state.publicPage.publicPageImages : null },
    publicPageLogo() { return this.publicPageImages != null ? this.publicPageImages.find(x => x.location == 'logo') : null },
    publicPage() { return this.$store.state.publicPage != null ? this.$store.state.publicPage.publicPage : {} },
    availableBookings() { return this.$store.state.publicPage != null ? this.$store.state.publicPage.availableBookings : [] },
    availableCourses() { return this.$store.state.publicPage != null ? this.$store.state.publicPage.availableCourses : [] },
     openApplications() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.openApplications : [] },
    instructors() { return this.$store.state.publicPage != null ? this.$store.state.publicPage.instructors : [] },
    customerName() { return this.$store.state.publicPage != null ? this.$store.state.publicPage.customerName : '' },
    tabs() { return this.$store.state.publicPage != null ? this.$store.state.publicPage.tabs : [] },
    settings() { return this.$store.state.publicPage != null ? this.$store.state.publicPage.settings : null },
    hasSettings() { return this.settings },
    selectedPage() { return this.$route.name },
    height() { return $(window).height() }
  },
  methods: {
    getColor(location) {
      return niceFunctions.getColor(this.publicPageColors, location)
    },
    getPageName(page) {
      return niceFunctions.getPageName(page)
    }
  },
  watch: {
    customerName(newvalue) {
      document.title = newvalue;
    }
  }
}
</script>

<template>
  <section class="MobileMenu" v-if="publicPageImages != null" v-fade-in>
    <div style="height: 73px; position: absolute; top: 5px; left: 5px;" v-if="publicPageLogo">
      <img :src="url + 'uploads/' + publicPageLogo.customer_id + '/images/' + publicPageLogo.image_name" style="height: 100%" />
    </div>
    <div class="MobileMenu-icon">
      <p @click="showMobileMenu = !showMobileMenu">
        <hr :class="showMobileMenu ? 'MobileMenu-line-fade-out' : 'MobileMenu-line-fader'">
        <hr :class="showMobileMenu ? 'MobileMenu-line-x' : 'MobileMenu-line-x-straight'">
        <hr :class="showMobileMenu ? 'MobileMenu-line-y' : 'MobileMenu-line-y-straight'">
        <hr :class="showMobileMenu ? 'MobileMenu-line-fade-out' : 'MobileMenu-line-fader'">
        <b v-if="!showMobileMenu">MENY</b>
      </p>
    </div>
    <div v-if="showMobileMenu">
      <div class="MobileMenu-links" :style="{ 'background-color': getColor('background_color'), 'height': height + 'px' }">

        <router-link
          class="MobileMenu-item"
          style="margin-top:50px;"
          :style="{ 'background-color': selectedPage === 'home' ? getColor('background_color') : '' }"
          :to="{ name: getPageName('home'), params: { id: $route.params.id } }"
          @click.native="showMobileMenu = false"
        >
          Hem
        </router-link>

        <router-link
          class="MobileMenu-item"
          :style="{ 'background-color': selectedPage === 'community' ? getColor('background_color') : '' }"
          :to="{ name: getPageName('community'), params: { id: $route.params.id } }"
          @click.native="showMobileMenu = false"
        >
          {{ hasSettings ? settings.Community.singular : '' }}
        </router-link>

        <router-link
          v-for="tab in tabs"
          :key="tab.id"
          class="MobileMenu-item"
          :to="{ name: getPageName('tab'), params: { id: $route.params.id, tabid: tab.id } }"
          @click.native="showMobileMenu = false"
        >
          {{ tab.name }}
        </router-link>

        <router-link v-if="availableCourses.length > 0"         
          class="MobileMenu-item"
          :to="{ name: getPageName('courses'), params: { id: $route.params.id } }"
          @click.native="showMobileMenu = false"
        >
          {{ hasSettings ? settings.Course.plural : '' }}
        </router-link>

        <router-link
          v-if="instructors.length > 0"
          class="MobileMenu-item"
          :to="{ name: getPageName('instructors'), params: { id: $route.params.id } }"
          @click.native="showMobileMenu = false"
        >
          {{ settings.CourseInstructor.plural }}
        </router-link>

        <router-link v-if="openApplications.length > 0" 
          class="MobileMenu-item"
          :to="{ name: getPageName('applications'), params: { id: $route.params.id } }"
          @click.native="showMobileMenu = false"
          >
          {{ hasSettings ? settings.OpenApplication.plural : '' }}
        </router-link>


        <router-link
          v-if="publicPage.include_image_gallery"
          class="MobileMenu-item"
          :style="{ 'background-color': selectedPage === 'imageGallery' ? getColor('background_color') : '' }"
          :to="{ name: getPageName('imageGallery'), params: { id: $route.params.id } }"
          @click.native="showMobileMenu = false"
        >
          {{ hasSettings ? settings.ImageGallery.singular : '' }}
        </router-link>

        <router-link
            v-if="availableBookings.length > 1"
            class="MobileMenu-item"
            :to="{ name: getPageName('bookings'), params: { id: $route.params.id } }"
            @click.native="showMobileMenu = false"
          >
          {{ hasSettings ? settings.BookingItem.plural : '' }}
          </router-link>

          <div v-if="availableBookings.length == 1">
            <router-link
              :key="availableBookings[0].id"
              class="MobileMenu-item"
              :to="{ name: getPageName(availableBookings[0].duration_unit === 'Timmar' ? 'bookingHoursAdd' : 'bookingDaysAdd'), params: { id: $route.params.id, bookingid: availableBookings[0].id } }"
              @click.native="showMobileMenu = false"
            >
              {{ availableBookings[0].name }}
            </router-link>
          </div>

        <router-link
          v-if="publicPage.include_contact"
          class="MobileMenu-item"
          :style="{ 'background-color': selectedPage === 'contact' ? getColor('background_color') : '' }"
          :to="{ name: getPageName('contact'), params: { id: $route.params.id } }"
          @click.native="showMobileMenu = false"
        >
          Kontakt
        </router-link>

        <div class="MobileMenu-bg">
          <img src="../assets/imgs/new_logo.png" style="opacity: 0.2; width: 130px" />
        </div>
      </div>
      <div class="MobileMenu-triangle" :style="{ 'border-left-color': getColor('background_color') }"></div>
    </div>
  </section>
</template>

<style scoped>
.MobileMenu-icon {
  overflow: auto;
  position: absolute;
  z-index: 100;
  right: 10px;
}
.MobileMenu-links {
  position: absolute;
  width: calc(100% - 140px);
  z-index: 10;
  top: 0px;
  padding-bottom: 100px;
}
.MobileMenu {
  color: black;
  position: fixed;
  z-index: 1002;
  top: 0px;
  left: 0px;
  right: 0px;
  font-family: Raleway, sans-serif;
}
.MobileMenu b {
  color: white;
  text-shadow: -1px -1px 0 rgb(0, 0, 0), 1px -1px 0 rgb(0, 0, 0), -1px 1px 0 rgb(0, 0, 0), 1px 1px 0 rgb(0, 0, 0);
}
.MobileMenu p {
  font-size: 11pt;
  font-weight: bold;
  text-align: center;
  margin: 17px 30px;
  width: 45px;
  float: right;
  cursor: pointer;
  font-family: Raleway, sans-serif;
}
.MobileMenu hr {
  height: 5px;
  width: 40px;
  margin: 2px;
  float: right;
  background-color: white;
  border: 1px solid black;
  border-radius: 3px;
}
.MobileMenu-line-fade-out {
  opacity: 0;
  transition: 0.3s;
}
.MobileMenu-line-x {
  transform: rotate(135deg);
  background-color: black !important;
  border: 1px solid black !important;
  transition: 0.3s;
}
.MobileMenu-line-y {
  transform: rotate(45deg);
  transition: 0.3s;
  background-color: black !important;
  border: 1px solid black !important;
  position: absolute;
  top: 28px;
  right: 30px;
}
.MobileMenu-line-y-straight {
  transform: rotate(0deg);
  transition: 0.3s;
  position: absolute;
  top: 28px;
  right: 30px;
}
.MobileMenu-line-x-straight {
  transform: rotate(180deg);
  transition: 0.3s;
}
.MobileMenu-line-fader {
  opacity: 1;
  transition: 0.6s;
}
.MobileMenu-item {
  font-size: 15pt;
  font-weight: bold;
  text-transform: uppercase;
  text-align: left;
  padding: 10px 40px;
  cursor: pointer;
  filter: brightness(90%);
}
.MobileMenu-triangle {
  width: 0;
  height: 0;
  border-bottom: 1500px solid transparent;
  border-left: 274px solid transparent;
  position: absolute;
  top: 0px;
  right: 0px;
}
.MobileMenu-bg {
  width: 150px;
  height: 150px;
  position: absolute;
  bottom: 140px;
  left: 0px;
  right: 0px;
  margin: auto;
}

a {
  display:block;
  color: black;
text-decoration: none;}

a:hover {
  text-decoration: none;
}
</style>
